// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    hmr: false,
    // baseUri: 'https://sigesa.com.ar/col5095/bk001/',                //IP SERVER CENTRAL (ALTERNATIVO)
    // backendUri: 'https://sigesa.com.ar/col5095/bk001/api/',         //IP SERVER CENTRAL (ALTERNATIVO)
    baseUri: 'https://apitest.sigesa.com.ar/',                //IP SERVER CENTRAL (ALTERNATIVO)
    backendUri: 'https://apitest.sigesa.com.ar/api/',         //IP SERVER CENTRAL (ALTERNATIVO)
    //baseUri: 'http://localhost:5000/',                //IP SERVER CENTRAL (ALTERNATIVO)
    //backendUri: 'http://localhost:5000/api/',         //IP SERVER CENTRAL (ALTERNATIVO)
    mapUri: 'https://maps.googleaspis.com/maps/api/',
    googleMapsApiUri: 'https://maps.googleapis.com/maps/api/',
    googleMapsApiKey: 'AIzaSyDkfd6Na_gRFN0nXYpkF9I-TyBspmRtQ3Q',
    colegio: '5095',
    logo: 'assets/images/logos/col5027.png',
    version: 'v2026.01.13',
    nombreCol: 'Colegio Secundario "Gral. San Martín"'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts